import { Skeleton } from "@chakra-ui/react";
import { Row, Col } from "antd";
import { FaInfoCircle } from "react-icons/fa";
import columns from "../CreateEditModal/columns";
import { Container, Span, Title } from "./styles";
import { ContainerTable, RoundedTable } from "../CreateEditModal/styles";

function LoadingSkeleton() {
  return (
    <Container>
      <Title>
        <FaInfoCircle size={18} /> Dados Gerais
      </Title>
      <Row gutter={[16, 16]} style={{ marginBottom: '14px' }}>
        <Col span={8} style={{ height: 94 }}>
          <Span>Código</Span>
          <Skeleton w="100%" h="41px" borderRadius={8} />
        </Col>

        <Col span={8} style={{ height: 94 }}>
          <Span>Descrição</Span>
          <Skeleton w="100%" h="41px" borderRadius={8} />
        </Col>
        <Col span={8} style={{ height: 94 }}>
          <Span>Safra</Span>
          <Skeleton w="100%" h="41px" borderRadius={8} />
        </Col>
      </Row>

      <Row gutter={[16, 16]}>
        <Col span={8} style={{ height: 94 }}>
          <Span>Fazenda</Span>
          <Skeleton w="100%" h="41px" borderRadius={8} />
        </Col>

        <Col span={8} style={{ height: 94 }}>
          <Span>Cultura</Span>
          <Skeleton w="100%" h="41px" borderRadius={8} />
        </Col>

        <Col span={8} style={{ height: 94 }}>
          <Span>Período de Produção</Span>
          <Skeleton w="100%" h="41px" borderRadius={8} />
        </Col>
      </Row>
      <Title>Operações</Title>
      <ContainerTable isOverflow>
        <RoundedTable
          style={{ marginBottom: 16 }}
          columns={columns(
            () => { },
            () => { },
            () => { },
            () => { },
            {}, [],
            () => { },
            () => { },
            [],
            () => { },
            false,
            () => {},
            false, {},
            () => {},
            '',
            () => {},
            '',
            () => {},
            () => {},
          )}
          dataSource={[]}
          className="my-table"
          sticky
          pagination={false}
        />
      </ContainerTable>
    </Container>
  );
}

export default LoadingSkeleton;
